export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = "http://127.0.0.1:8000/api/";

export const LOGIN_ENDPOINT = 'auth/login/'
export const LOGOUT_ENDPOINT = 'auth/logout/'
export const AI_AGENTS = 'ai_agents/'
export const SYSTEM_AI_AGENTS ='system_ai_agents/active/'
export const REFRESH_TOKEN ='auth/refresh/'
export const SYSTEM_AI_PROFILE ='/system_ai_agents/'
export const OCR_FIELDS ='system_ai_agent/'
export const PROFILE_API ='myprofile/'
export const CREATE_AI_AGENT = 'ai_agent/'
export const TASK_STATUS ='task_status/'
export const PROCESSED_DOCUMENTS='processed_documents/latest/'
export const PROCESSED_DOCUMENTS_DETAILS='processed_documents/'
export const DOWNLOAD_FILE_RESULT='file/download/result/'
export const DOWNLOAD_FILE='file/download/original/'
export const OCR_FIELDS_EDIT_GET = 'agent_ocr_fields/'
export const DELETE_AI_AGENT = 'ai_agent/';

